import * as fs from 'fs';
import * as path from 'path';

function hasSurveyProjectMarkers(root: string): boolean {
  if (fs.existsSync(path.join(root, 'src', 'components', 'Question.tsx'))) return true;
  if (fs.existsSync(path.join(root, 'implementation_plan.md'))) return true;
  const pkgPath = path.join(root, 'package.json');
  if (fs.existsSync(pkgPath)) {
    try {
      const pkg = JSON.parse(fs.readFileSync(pkgPath, 'utf8')) as {
        dependencies?: Record<string, string>;
        devDependencies?: Record<string, string>;
      };
      const deps = { ...pkg.dependencies, ...pkg.devDependencies };
      if (
        deps['@explorer02/cfm-survey-sdk'] ||
        deps['@repo/sdk'] ||
        Object.keys(deps).some(key => key.includes('cfm-survey-sdk'))
      ) {
        return true;
      }
    } catch {
      return false;
    }
  }
  return false;
}

/** Prefer cwd with survey project markers over stale INIT_CWD from yarn. */
export function resolveProjectRoot(explicit?: string): string {
  if (explicit) return explicit;
  const cwd = process.cwd();
  if (hasSurveyProjectMarkers(cwd)) return cwd;
  const initCwd = process.env.INIT_CWD;
  if (initCwd && hasSurveyProjectMarkers(initCwd)) {
    return initCwd;
  }
  return cwd;
}
